import { createRouter, createWebHistory } from 'vue-router';
import { useParentAuthStore } from '../store/auth';

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/parent'
  },
  {
    path: '/parent',
    name: 'parent',
    component: () => import('@/views/ParentsView.vue'),
    children: [
      {
        path: '',
        name: 'parent-home',
        redirect: { name: 'parent-notices' } 
      },
      {
        path: 'students',
        name: 'parent-students',
        component: () => import('@/views/StudentsView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'notices',
        name: 'parent-notices',
        component: () => import('@/views/NoticesView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'schedule',
        name: 'parent-schedule',
        component: () => import('@/views/ScheduleView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'assessment',
        name: 'parent-assessment',
        component: () => import('@/views/AssessmentView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'chat',
        name: 'parent-chat',
        component: () => import('@/views/ChatView.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: { name: 'parent-notices' } 
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});
router.beforeEach((to, from, next) => {
  const authStore = useParentAuthStore();

  const isAuthenticated = authStore.state.isAuthenticated;
  
  console.log('📍 Navigation:', { 
    to: to.path, 
    isAuthenticated,
    hasToken: !!authStore.state.access_token
  });
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('⛔ Not authenticated, but no login page - allowing?');
    
    next();
    return;
  }
  
  next();
});
export default router;